import Swal from "sweetalert2";
import {
  getSitesList,
} from "../services/Organization-services";
import { formFieldsData } from "../services/constant";
import { triggerServerErrorModal } from '../handlers/ServerErrorContext';
import { getLocalStorageData } from "./axiosComponent";
export const getMethods = (service, policyName) => {

  if (service == "Approval"){
    return {
      PUT: 1,
      POST: 1,
      GET: 1,
      DELETE: 1,
      PATCH: 1,
    }
  }
    var data = getLocalStorageData("profileDetails")
      ["_ACCESSIBILITIES_"].find((item) => item.service == service)
      .policies.find((item) => item.name == policyName);
  var methods = {
    PUT: 0,
    POST: 0,
    GET: 0,
    DELETE: 0,
    PATCH: 0,
  };
  // console.log(data.permissions, "data.permissions");
  data.permissions.split(",").forEach((method) => {
    methods[method] = 1;
  });

  return methods;
};

export const getDefaultColumns = (service, policyName) => {
  try {
    const profileDetails = getLocalStorageData("profileDetails");
    if (!profileDetails) {
      console.warn("Profile details not found in localStorage");
      return {};
    }
    const parsedProfile = profileDetails;
    if (!parsedProfile["_ACCESSIBILITIES_"]) {
      console.warn("Invalid profile structure: missing accessibilities");
      return {};
    }
    const serviceData = parsedProfile["_ACCESSIBILITIES_"].find(
      (item) => item.service === service
    );
    if (!serviceData) {
      console.warn(`Service "${service}" not found`);
      return {};
    }
    const policyData = serviceData.policies.find(
      (item) => item.name === policyName
    );
    if (!policyData) {
      console.warn(`Policy "${policyName}" not found for service "${service}"`);
      return {};
    }
    if (!policyData.fields) {
      console.warn(`No fields found for policy "${policyName}"`);
      return {};
    }
    const columns = {};
    policyData.fields.split(",").forEach((item) => {
      if(item.trim()!="*") 
      columns[item.trim()] = true;
    });
    return columns;
  } catch (error) {
    console.error("Error in getDefaultColumns:", error);
    return {};
  }
};

export const callToast = (icon, title, message) => {
  var myButton = document.getElementById("notification98");
  myButton.addEventListener("click", () => {
    Swal.fire({
      toast: true,
      icon: icon,
      position: "top-end",
      title: title,
      text: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  });
  myButton.click();
};

export const showErrorMessages = async ({
  data,
  navigate,
  formFilds = null,
} = {}) => {
  console.log("dataaaaaa", data);
  console.log("formFilds", formFilds);
  if (
    data == null ||
    data == undefined ||
    data.errors == undefined ||
    data.errors == null
  ) {
    triggerServerErrorModal(true);
    return;
  }
  //formFIles=[[field1,field2],[field3,field4]]
  if (data?.statusCode == 401) {
    localStorage.clear();
    navigate("/auth/sign-in", {
      replace: true,
      state: { clearStack: true },
    });
  }
  if (data.errors == undefined) {
    callToast("error", "FAILURE", data.message);
    return;
  }
  var message = "";
  data.errors.failures.map((item) => {
    if (item.code == "AU014") {
      navigate("/auth/sign-in", {
        replace: true,
        state: { clearStack: true },
      });
      callToast("error", "FAILURE", item.message);
      return;
    }
    callToast("error", "FAILURE", item.message);
  });

  if (formFilds != null && formFilds.length > 0) {
    var fieldData = {};
    Object.entries(data.errors.fieldErrors).map(([key, value]) => {
      var fieldAddress = getFieldAddress(formFilds, key);

      var messageData = "";
      value.map((msg) => {
        var message = msg.message;

        message.replace(key, formFieldsData[key].label);
        messageData += message + ",";
      });
      fieldData[key] = {
        step: fieldAddress,
        message: messageData,
      };
    });
    return fieldData;
  } else {
    Object.entries(data.errors.fieldErrors).map(([key, value]) => {
      value.map((msg) => {
        message += msg.message + "\n";
      });
    });
    if (message != "") {
      callToast("error", "FAILURE", message);
    }
  }
};

export const createPathTONavigate = (path, params) => {
  console.log("params in createNavi", params);
  Object.entries(params).map(([key, value]) => {
    console.log(key, value);
    path = path.replace(`:${key}`, value);
  });
  return path;
};

const getFieldAddress = (arr, field) => {
  for (let index = 0; index < arr.length; index++) {
    const step = arr[index];
    for (let fieldName of step) {
      if (fieldName === field) {
        return index + 1;
      }
    }
  }
  return null; // Return null if no match found
};
const filterUniqueByValue = (array) => {
  return Array.from(new Set(array.map((item) => item.value))).map((value) => {
    return array.find((item) => item.value === value);
  });
};
export const prepareRegionList = () => {
  var regionAccess = [];

  var data = getLocalStorageData("profileDetails");

  //for region access
  if (data["_REGION_ACCESS_"] != null && data["_REGION_ACCESS_"].length > 0) {
    data["_REGION_ACCESS_"].map((item) => {
      if (item.STATUS == "Y") {
        regionAccess.push({
          ...item,
          value: item._ID,
          label: item.NAME,
        });
      }
    });
    console.log("regionAccess pusjed from region", regionAccess);
  } else {
    regionAccess.push({
      value: data["_REGION"],
      label: data["REGION"],
    });
    localStorage.setItem(
      "regionList",
      JSON.stringify(filterUniqueByValue(regionAccess))
    );
    return;
  }

  //for site access
  var siteAccess = data["_SITE ACCESS_"];
  if (siteAccess != null && siteAccess.length > 0) {
    siteAccess.map((item) => {
      regionAccess.push({
        value: item["_REGION"],
        label: item["REGION"],
      });
    });
  }

  //for login
  regionAccess.push({
    value: data["_REGION"],
    label: data["REGION"],
  });
  console.log("regionAccess", regionAccess);
  localStorage.setItem(
    "regionList",
    JSON.stringify(filterUniqueByValue(regionAccess))
  );
  return filterUniqueByValue(regionAccess);
};

export const prepareSiteList = async (regionId, navigate, query) => {
  const data = getLocalStorageData("profileDetails");

  // Case 1: Selected region is in region access
  if (data["_REGION_ACCESS_"] && data["_REGION_ACCESS_"].length > 0) {
    for (const item of data["_REGION_ACCESS_"]) {
      if (item._ID === regionId) {
        const res = await getSitesList({ regionId, status: "Y", query: query });
        console.log("case 1", res);
        if (res.status === "success") {
          res.data.entityList.forEach((site) => {
            site.value = site._ID;
            site.label = site.NAME;
          });
          console.log("case 1.1", res.data.entityList);
          return res.data.entityList;
        } else {
          showErrorMessages({ data: res, navigate });
        }
      }
    }
  }

  // Case 2: Selected region is the login region
  if (regionId === data["_REGION"]) {
    var res = await getSitesList({ status: "Y", query: query });
    console.log("case 2", res);
    if (res.status === "success") {
      var siteList = res.data.entityList.filter(
        (item) => item._REGION === regionId
      );
      siteList.forEach((item) => {
        item.value = item._ID;
        item.label = item.NAME;
      });
      console.log("case 2", siteList);
      return siteList;
    } else {
      showErrorMessages({ data: res, navigate });
    }
  }

  // Case 3: Not in login region or region access, it exists in site access
  var siteList = data["_SITE ACCESS_"].map((item) => ({
    value: item._ID,
    label: item.NAME,
  }));

  return siteList;
};

export const checkIfCodeExistsInFailures = (data, code) => {
  if (
    data == null ||
    data == undefined ||
    data.errors == undefined ||
    data.errors == null
  ) {
    return false;
  }
  return data.errors.failures.some((item) => item.code === code);
};

export const getMasterActionStatusFieldName = (service) => {
  switch (service) {
    case "Tutor Homework":
      return "Publish";
    case "Tutor Assignment":
      return "Publish";

    default:
      return "status";
  }
};
export const getMasterActionStatusValue = (fieldName, status) => {
  switch (fieldName) {
    case "Publish":
      return status == "Y" ? "Published" : "Unpublished";

    default:
      return status == "Y" ? "Active" : "In Active";
  }
};
